import React from 'react';

export const Footer = () => (
  <div className='py-5 text-center border-solid border-t border-[#eee] mt-2 font-poppins px-3 leading-6'>
    Copyright © {new Date().getFullYear()} All Rights Reserved by Lazy Lawn®
  </div>
);
